import { carouselItems } from "@/mocks/homeData";

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            编辑团队精心策划的影视专题，带你深入光影世界
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="relative rounded-2xl overflow-hidden cursor-pointer group h-[320px] md:h-[360px]"
            >
              <img
                src={item.image}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/20"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <span className="inline-block px-3 py-1 rounded-full text-[11px] font-semibold bg-accent-500 text-background-50 mb-3 font-label">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-foreground-50 mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-200/80 leading-relaxed line-clamp-2 max-w-md">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}